// extracted by mini-css-extract-plugin
export default {"modal":"PokemonModalBody_modal__7-axe","backdrop":"PokemonModalBody_backdrop__tCXjc"};